import React, { Component } from 'react';
import { observer } from 'mobx-react';

import { PageHeader, Tag } from 'antd';

import { pageHeaderStyle, pageTitle } from '../util/Style';

import { AgGridReact } from 'ag-grid-react';

import InvoiceSummaryStore from '../stores/InvoiceSummaryStore';

const height = window.innerHeight * .80;

const defaultColDef = {
    sortable: true,
    resizable: true,
    filter: true,
    flex: 1,
    width: 100,
};

const dueGetter = (params) => {
    return params.data.Total - params.data.Advance;
};

const columnDefs = [
    { headerName: 'Branch', field: 'BranchId', type: 'numericColumn' },
    { headerName: 'Branch Name', field: 'BranchName' },
    { headerName: 'Lab Name', field: 'LabName' },
    { headerName: 'Bill Count', field: 'BillCount', type: 'numericColumn', filter: 'agNumberColumnFilter', headerClass: 'ag-right-aligned-header', cellClass: 'ag-right-aligned-cell' },
    { headerName: 'Total Bill Amount', field: 'Total', type: 'numericColumn', filter: 'agNumberColumnFilter', headerClass: 'ag-right-aligned-header', cellClass: 'ag-right-aligned-cell' },
    { headerName: 'Received', field: 'Advance', type: 'numericColumn', filter: 'agNumberColumnFilter', headerClass: 'ag-right-aligned-header', cellClass: 'ag-right-aligned-cell' },
    { headerName: 'Due', field: 'Due', valueGetter: dueGetter, type: 'numericColumn', filter: 'agNumberColumnFilter', headerClass: 'ag-right-aligned-header', cellClass: 'ag-right-aligned-cell' },
];

class InvoiceSummaryUI extends Component {

    gridRef = React.createRef();

    constructor(props) {
        super(props);
        this.store = props.store;
    }

    fetchInvoices = () => {
        this.store.fetchInvoices();
    }

    countTag = () => {
        if (this.store.isDone) {
            return <Tag color="#108ee9">{this.store.rowCount} Total</Tag>
        }

        if (this.store.isError) {
            return <Tag color="red">...</Tag>
        }
    }


    onSelectionChanged = () => {
        const selectedRows = this.gridRef.current.api.getSelectedRows();

        const referrerId = selectedRows[0].ReferrerId;
        const labName = selectedRows[0].LabName;
        const collectionType = this.store.collectionType;
        
        const params = { parentKey: "invoices", referrerId, labName, collectionType };

        this.props.appStore.currentComponent = { label: "Lab Invoice Details", key: "labInvoiceDetails", params: params };
    }

    render() {
        const invoices = this.store.invoices;
        return (
            <>
                <PageHeader style={pageHeaderStyle} title={pageTitle("Invoices")} tags={this.countTag()}>
                </PageHeader>
                <div className="ag-theme-alpine" style={{ height: height, width: '100%' }}>
                    <AgGridReact
                        rowHeight={30}
                        ref={this.gridRef}
                        defaultColDef={defaultColDef}
                        rowData={invoices}
                        rowSelection={'single'}
                        onSelectionChanged={this.onSelectionChanged}
                        columnDefs={columnDefs}
                        onGridReady={this.fetchInvoices}>
                    </AgGridReact>
                </div>
            </>
        )
    }
}

export default observer(InvoiceSummaryUI)
